import { Component, input } from '@angular/core';

/**
 * Loading de tela cheia para transições entre telas ou carregamento de conteúdo.
 * Ocupa o espaço disponível do container pai e centraliza o spinner;
 * a mensagem é opcional.
 */
@Component({
  selector: 'app-page-loader',
  imports: [],
  templateUrl: './page-loader.html',
  styleUrl: './page-loader.scss',
})
export class PageLoader {
  readonly message = input<string | null>(null);
}
